const options = {
    root: null,
    rootMargin: '100px 0px',
    threshold: 0
};

// IMAGES
/*document.addEventListener('DOMContentLoaded', () => {
    const lazyImages =[].slice.call(document.querySelectorAll('img.js-lazy-load'));
    if ('IntersectionObserver' in window) {
        let lazyImageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(function(image) {
                if (image.intersectionRatio > lazyImageObserver.thresholds[0]) {
                    let lazyImage = image.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove('js-lazy-load');
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }, options);
        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }
});*/

// BACKGROUND IMAGES
/*document.addEventListener('DOMContentLoaded', function() {
    const lazyBgimages = [].slice.call(document.querySelectorAll('div.js-lazy-load'));
    if ('IntersectionObserver' in window) {
        const lazyBgimageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(bgimage) {
                if (bgimage.intersectionRatio > lazyBgimageObserver.thresholds[0]) {
                    let lazyBgimage = bgimage.target;
                    lazyBgimage.classList.add('visible');
                    lazyBgimage.classList.remove('js-lazy-load');
                    lazyBgimageObserver.unobserve(lazyBgimage);
                }
            });
        }, options);
        lazyBgimages.forEach(function(lazyBgimage) {
            lazyBgimageObserver.observe(lazyBgimage);
        });
    }
});*/

// VIDEOS
document.addEventListener('DOMContentLoaded', function() {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.js-lazy-load'));
    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.intersectionRatio > lazyVideoObserver.thresholds[0]) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }
                    video.target.load();
                    video.target.classList.remove('js-lazy-load');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        }, options);
        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});